import React from 'react'
import total_logo from '../assets/images/logos/total.svg'
import shell_logo from '../assets/images/logos/shell.svg'
import NNPC_logo from '../assets/images/logos/NNPC.svg'
import petronas_logo from '../assets/images/logos/petronas-2.svg'
import schlumberger_logo from '../assets/images/logos/schlumberger-2.svg'
import chiyoda_logo from '../assets/images/logos/chiyoda-corporation-company-logo.svg'
import tullow_logo from '../assets/images/logos/tullow-oil-logo.svg'
import vattenfall_logo from '../assets/images/logos/vattenfall.svg'


const About = () => {

    
  return (
    <div className='max-w-[1240px] mx-auto overflow-hidden '>
      <div className="py-16 ">
    <div className="container m-auto px-6 space-y-8 md:px-12 lg:px-16">
        <div className="m-auto text-center lg:w-7/12">
            <h2 className="text-2xl text-gray-700 font-bold md:text-4xl">Your favorite companies are our partners.</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
            <div className="p-4">
                <img src={total_logo} className="w-32 h-32" alt=""/>
            </div>
            <div className="p-4">
                <img src={shell_logo}className="w-32 h-32 " alt=""/>
            </div>
            <div className="p-4">
                <img src={NNPC_logo} className="w-32 h-32 " alt=""/>
            </div>
            <div className="p-4">
                <img src={petronas_logo} className="w-32 h-32 " alt=""/>
            </div>
            <div className="p-4">
                <img src={schlumberger_logo}className="w-32 h-32" alt=""/>
            </div>
            <div className="p-4">
                <img src={chiyoda_logo}className="w-32 h-32" alt=""/>
            </div>
            <div className="p-4">
                <img src={tullow_logo} className="w-32 h-32" alt=""/>
            </div>
            <div className="p-4">
                <img src={vattenfall_logo} className="w-32 h-32" alt="/"/>
            </div>
        </div>
    </div>
</div>
                                    
    </div>
  )
}

export default About